// extracted by mini-css-extract-plugin
module.exports = {"content":"ExpandableContent__content__9389e4e","expanded":"ExpandableContent__expanded__9389e4e"};